import { fabric } from 'fabric';

fabric.Object.prototype.originX = 'center';
fabric.Object.prototype.originY = 'center';
fabric.Object.prototype.centeredRotation = true;
